import { FC, Fragment } from "react";

export type DescriptionItemProps = {
  text: string;
};

export const DescriptionItemCart: FC<DescriptionItemProps> = ({ text }) => {
  return (
    <Fragment>
      <dd className="text-sm font-medium text-gray-900">{text}</dd>
    </Fragment>
  );
};
